import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" className="py-12 md:py-20 px-4 md:px-8 bg-cream border-y border-slate-200" data-id="element-124">
      <div className="max-w-3xl mx-auto text-center" data-id="element-125">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-24 h-24 md:w-32 md:h-32 bg-white rounded-full shadow-lg border-4 border-teal-100 mb-6 md:mb-8 relative" data-id="element-126">
          <div className="absolute inset-0 border-2 border-dashed border-teal-300 rounded-full m-2 animate-[spin_20s_linear_infinite]" data-id="element-127"></div>
          <div className="flex flex-col items-center justify-center text-teal-900" data-id="element-128">
            <ShieldCheckIcon size={24} className="mb-1" data-id="element-129" />
            <span className="font-bold text-xs md:text-sm leading-tight" data-id="element-130">
              7 DÍAS
            </span>
            <span className="text-[9px] md:text-[10px] uppercase font-bold tracking-wider" data-id="element-131">
              Garantía
            </span>
          </div>
        </motion.div>

        <h2 className="text-2xl md:text-4xl font-bold font-serif text-teal-900 mb-4 md:mb-6 leading-tight" data-id="element-132">
          7 días para probarlo o te devolvemos el 100%
        </h2>

        <p className="text-sm md:text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-133">
          Abrís los tomos, usás las plantillas en tu próxima sesión. Si no es lo
          que esperabas: sin preguntas, sin formularios, sin drama.{' '}
          <span className="font-medium text-slate-500" data-id="element-134">
            (Tasa de devoluciones menor al 1%)
          </span>
        </p>
      </div>
    </section>;
}